<template>
  <div>
    <div>
      <p class="icon-jujue closeBtn" @click="routerBack"></p>
    </div>
    <div class="content_box">
      <el-row style="margin:5px 0">
        <el-button size="mini" class="btn" type="primary" @click="onSave('SAVE')" v-if="$route.query.status!=='SUBMITTED'" v-acl="QSPI_DQMP_SAVE">保存</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onSave('SUBMIT')" v-acl="QSPI_DQMP_SAVE">提交</el-button>
      </el-row>
      <el-form ref="formatRules" :model="formatRules">
        <el-table ref="plxTable" :data="formatRules.tableData" max-height="500" border highlight-current-row>
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column align="center" label="评价月" prop="month" min-width="100"></el-table-column>
          <el-table-column align="center" label="DC编码" prop="dcCode" min-width="120"></el-table-column>
          <el-table-column align="center" label="DC名称" prop="dcName" min-width="150"></el-table-column>
          <el-table-column align="center" label="Outbound" prop="outbound" min-width="180"></el-table-column>
          <el-table-column align="center" label="分数" prop="score" min-width="90">
            <template slot-scope="scope">
              <el-form-item :prop="`tableData.${scope.$index}.score`">
                <el-input v-model="scope.row.score" @change="scoreChange(scope.row,$event,scope.$index)"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column align="center" label="等级" prop="grade" min-width="90"></el-table-column>
          <el-table-column align="center" label="状态" prop="statusI18n" min-width="90"></el-table-column>
          <el-table-column align="center" label="附件" min-width="120">
            <template slot-scope="scope">
              <el-popover placement="right" width="300" trigger="click">
                <el-table :data="JSON.parse(scope.row.files)" style="width:100%">
                  <el-table-column type="index" label="序号" width="60px"></el-table-column>
                  <el-table-column show-overflow-tooltip property="documentName" label="文件名称">
                    <template slot-scope="scope">
                      <el-button @click="onDownload(scope.row)" type="text" size="small">{{scope.row.documentName}}</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-button type="text" slot="reference">查看附件</el-button>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column align="center" label="更新人" prop="updateName" min-width="150"></el-table-column>
          <el-table-column align="center" label="更新日期" prop="updateDate" min-width="120"></el-table-column>
          <el-table-column align="center" label="操作" min-width="100" v-acl="QSPI_DQMP_UPLOAD_ATT">
            <template v-slot="scope">
              <el-button type="text" @click="onUpload(scope.row,scope.$index)">上传附件</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </div>
    <el-dialog title="附件" :visible.sync="dialogTableVisible" class="dqmp_dialog">
      <el-row style="margin-bottom:5px">
        <el-upload ref="upload" action="upload" :http-request="uploadConfirm" :show-file-list="false" multiple name="file">
          <el-button slot="trigger" size="small" type="primary">{{$t('common.upload')}}</el-button>
        </el-upload>
      </el-row>
      <el-table :data="gridData">
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column show-overflow-tooltip property="documentName" label="文件名称"></el-table-column>
        <el-table-column show-overflow-tooltip property="userName" label="上传人"></el-table-column>
        <el-table-column show-overflow-tooltip property="createDate" label="上传时间"></el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <el-button @click="onDel(scope.row.tmDocumentId,scope.$index,gridData)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import store from '@/store/index';
import DQMPApi from "@/api/DQMP/index";
import otherApi from "@/api/other/index";
import QBRApi from "@/api/QBR/index";
import { fileService } from "@/api/common/file-utils";
export default {
  name: 'dqmpDetail',
  data() {
    return {
      formatRules: {
        tableData: []
      },
      gridData: [],
      fileList: [],
      dialogTableVisible: false,
      ttQspiDqmpId: '',
      rules: {},
      ttQspiDqmpId: ""
    }
  },
  mounted() {
    this.getDetailInfo()
  },
  watch: {
    gridData: {
      handler(newV, oldV) {
        console.log('newV', newV);
        console.log('ttQspiDqmpId', this.ttQspiDqmpId);
        console.log('this.formatRules.tableData', this.formatRules.tableData);
        this.formatRules.tableData.forEach(ele => {
          if (ele.ttQspiDqmpId === this.ttQspiDqmpId) {
            ele.files = newV
          }
        })
      }
    }
  },
  methods: {
    getDetailInfo() {
      var ttQspiDqmpIdList = JSON.parse(sessionStorage.getItem('ttQspiDqmpIdList'))
      DQMPApi.findDqmpListPage({
        ttQspiDqmpIdList: ttQspiDqmpIdList,
        pageSize: -1,
      }).then(res => {
        this.formatRules.tableData = res.data.records;
      });
    },
    renderHeader(h, { column, $index }) {
      return h("span", [
        h("span", { class: "mandatory" }),
        h("span", column.label)
      ]);
    },
    scoreChange(row, val, index) {
      if (val) {
        var reg = /^[0-9]+(\.[0-9]{0,1})?$/
        if (!reg.test(val)) {
          this.$my_message('分数只能输入大于等于0的正数,有且仅能保留一位小数', 'error')
          return false
        }
        otherApi.findGradeToScore('DQMP', val).then(res => {
          if (res.code === '200') {
            row.grade = res.data
          }
        });
      } else {
        row.grade = ''
      }
    },
    onUpload(row, index) {
      this.ttQspiDqmpId = row.ttQspiDqmpId
      this.dialogTableVisible = true
      this.ttQspiDqmpId = row.ttQspiDqmpId
      this.getFileLists(row.ttQspiDqmpId)
    },
    uploadConfirm(item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      //调用成功后调用后台方法进行文件关系维护
      fileService.fileUpload(formData).then(res => {
        let attachment = {};
        attachment.seq = "1";
        attachment.documents = res.data[0];
        attachment.tsRecId = this.ttQspiDqmpId;
        attachment.tsReckindId = "QSPI-DQMP-FILE";
        fileService.saveFile(attachment).then(saveRes => {
          _this.getFileLists(this.ttQspiDqmpId);
        });
      }).catch(error => {
        //文件上传失败
        _this.$message({
          type: "error",
          message: _this.$t("common.fileUploadFailed")
        });
      });
    },
    getFileLists(ttQspiDqmpId) {
      QBRApi.getFileLists({
        seq: '1',
        tsReckindId: "QSPI-DQMP-FILE",
        tsRecId: ttQspiDqmpId
      }).then(res => {
        this.gridData = res
      });
    },
    onDel(tmDocumentId, index, files) {
      if (tmDocumentId) {
        fileService.deleteFile(tmDocumentId).then((res) => {
          if (res.code === '200') {
            files.splice(index, 1);
          }
        })
      } else {
        //还没保存
        files.splice(index, 1);
      }
    },
    onSave(type) {
      console.log('type', type);
      var valid = false
      for (let i = 0; i < this.formatRules.tableData.length; i++) {
        const ele = this.formatRules.tableData[i];
        if (ele.score) {
          var reg = /^[0-9]+(\.[0-9]{0,1})?$/
          if (!reg.test(ele.score)) {
            this.$my_message('第' + (i + 1) + '行,分数只能输入大于等于0的正数,有且仅能保留一位小数', 'error')
            valid = true
          }
        }
      }
      if (valid) {
        return;
      }
      if (type == 'SAVE') {
        DQMPApi.updateBatchDqmp(type, this.formatRules.tableData).then(res => {
          if (res.meta.code === 200) {
            this.$message.success('保存成功')
            this.getDetailInfo()
          }
        });
      }
      if (type == 'SUBMIT') {
        let flag = false
        for (let i = 0; i < this.formatRules.tableData.length; i++) {
          const ele = this.formatRules.tableData[i];
          console.log('ele.files', ele.files);
          if (ele.lastMonthScore !== ele.score && (!ele.files || ele.files.length === 0)) {
            this.$my_message('第' + (i + 1) + '行,请上传附件', 'error')
            flag = true
          }
        }
        if (flag) {
          return;
        }
        this.$refs['formatRules'].validate((valid) => {
          if (valid) {
            DQMPApi.updateBatchDqmp(type, this.formatRules.tableData).then(res => {
              if (res.meta.code === 200) {
                this.$message.success('提交成功')
                this.$router.go(-1)
              }
            });
          }
        })
      }
    },
    onDownload(row) {
      fileService.downloadFile(row).then((res) => { })
    },
    routerBack() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
</style>